import createRemoteSettingHook from '@/utils/user/createRemoteSettingHook';

interface HideShareSetting {
  hidden: boolean;
}

const REMOTE_SETTING_NAME = 'genai_studio_hide_share';

const DEFAULT_SETTING: HideShareSetting = {
  hidden: false,
};

const isHideShareSetting = (settings: unknown): settings is HideShareSetting =>
  typeof settings === 'object' &&
  settings !== null &&
  typeof (settings as HideShareSetting).hidden === 'boolean';

const { useSetting } = createRemoteSettingHook({
  name: REMOTE_SETTING_NAME,
  defaultValue: DEFAULT_SETTING,
  validate: isHideShareSetting,
  select: (settings) => settings.hidden,
});

/**
 * Remote-setting gate for the Share action. When `genai_studio_hide_share.hidden`
 * is `true`, Share is hidden everywhere (creation cards + lightbox). Defaults to
 * shown; fetched once per session.
 */
const useHideShare = useSetting;

export default useHideShare;
